import React from "react";
import { SkeletonText } from "./SkeletonText";
import { SkeletonBox } from "./SkeletonBox";
import { SkeletonWidth } from "@/common/skeleton.common";
import { cn } from "@/lib/utils";

interface FormFieldSkeletonProps {
  type?: "input" | "textarea" | "select";
  hasLabel?: boolean;
  labelWidth?: SkeletonWidth;
  className?: string;
}

const FIELD_HEIGHTS = {
  input: "h-10",
  textarea: "h-20", 
  select: "h-10",
} as const;

export const FormFieldSkeleton = React.memo<FormFieldSkeletonProps>(({
  type = "input",
  hasLabel = true,
  labelWidth = "md",
  className
}) => {
  const fieldHeight = FIELD_HEIGHTS[type];

  return (
    <div className={cn("space-y-2", className)} aria-hidden="true">
      {hasLabel && (
        <SkeletonText size="sm" width={labelWidth} />
      )}
      
      <SkeletonBox 
        width="w-full" 
        height={fieldHeight} 
        className="rounded-md"
      />
    </div>
  );
});

FormFieldSkeleton.displayName = "FormFieldSkeleton"; 